export default __webpack_public_path__ + "static/bar-chart-c746eb7d631a36b0b15f0267d51614bd.png";